<template>
    <v-card
        class="grey lighten-4 pa-10"
        style="max-width: 680px; min-width: 400px;"
    >
        <triangle-div
            corner="bottom-left"
            borderBottom="130px solid #00B1C3"
            borderLeft="0px solid transparent"
            borderRight="180px solid transparent"
        ></triangle-div>

        <p class="pb-7">With a history deeply rooted in diversified manufacturing, we 
            specialize in the design, development, and manufacturing of superior
            automotive parts. Serving a wide range of customers we make a variety of
            quality parts, including but not limited to; engine mounts, strut, body
            and member mounts, and suspension bushings.
        </p>

        <p class="pb-14">Through hardwork, dedication, and experience we have honed our craft and
        wear our mission statement on our sleeve.  Everyday we aim to <span class="font-weight-bold">Serve Society
        with Superior Quality.</span>
        </p>
    </v-card>
</template>

<script>
import TriangleDiv from '@/components/TriangleDiv.vue'

export default {
    components: {
      'triangle-div': TriangleDiv,
    },
    name: "HistoryCard"
}
</script>